module.exports = __webpack_public_path__ + "media/video2.2a54eab7.mp4";